import { PostalAddress } from "../model/PostalAddress";

export function getGoogleMapsUrl(postalAddress: PostalAddress | undefined | null): string | undefined {
  if (!postalAddress) return undefined;
  const mapsURL = "https://www.google.com/maps/search/?api=1&query=";
  let query = "";
  if (postalAddress.street) {
    query += postalAddress.street;
  }
  if (postalAddress.postalCode) {
    query += " " + postalAddress.postalCode;
  }
  if (postalAddress.city) {
    query += " " + postalAddress.city;
  }
  if (postalAddress.geoCoordinates && !query) {
    query += "&query_place_id=" + postalAddress.geoCoordinates.lat + "," + postalAddress.geoCoordinates.lng;
  }
  const encodedMapsUrl = query ? encodeURI(mapsURL + query) : undefined;
  return encodedMapsUrl;
}
